import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  CloseSubmissionConflictErrorModal,
  ReloadDesignationsTab
} from '../../state/designations/actions';

@Component({
  selector: 'muni-shared-submission-conflict-error-modal',
  templateUrl: './submission-conflict-error-modal.component.html',
  styleUrls: [
    './submission-conflict-error-modal.component.scss'
  ]
})
export class SubmissionConflictErrorModalComponent {
  constructor(
    private store: Store
  ) { }

  public reloadPage(): void {
    this.closeModal();
    this.store.dispatch(new ReloadDesignationsTab());
  }

  public closeModal(): void {
    this.store.dispatch(new CloseSubmissionConflictErrorModal());
  }
}